import {
  Card,
  CardContent,
  Link,
  Breadcrumbs as MuiBreadcrumbs,
  Divider as MuiDivider,
  Tab,
  Tabs,
  TextField,
  Typography,
  makeStyles,
} from "@material-ui/core";
import { ContentState, EditorState } from "draft-js";
import { NavLink, useHistory } from "react-router-dom";
import {
  deleteApplicationKind,
  fetchApplicationKinds,
} from "../../services/applicationKindsService";
import { useEffect, useState } from "react";

import { Autocomplete } from "@material-ui/lab";
import CustomAlert from "../components/CustomAlert";
import CustomTable from "../../components/GovGrMaterialTable";
import { Helmet } from "react-helmet-async";
import SwipeableViews from "react-swipeable-views";
import { Visibility } from "@material-ui/icons";
import dayjs from "dayjs";
import { fetchFinishedApplications } from "../../services/applicationsService";
import { fetchPortAuthorities } from "../../services/portAuthoritiesService";
import htmlToDraft from "html-to-draftjs";
import { spacing } from "@material-ui/system";
import styled from "styled-components/macro";
import useLocale from "../../hooks/useLocale";
import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import { portAuthoritySort } from "../../utils/portAuthoritySort";
import GovGrCard from "../../components/GovGrCard";

const Divider = styled(MuiDivider)(spacing);
const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const useStyles = makeStyles({
  viewDetails: {
    width: 700,
    height: 400,
  },
  card: {
    marginTop: "1rem",
    marginBottom: "1.5rem",
  },
  applicationCard: {
    maxWidth: "80vw",
  },
});

const ApplicationsHistory = () => {
  const { t } = useLocale();
  const [activeTab, setActiveTab] = useState(0);

  const [portAuthId, setportAuthId] = useState(
    useSelector((state) => state?.authReducer?.user?.port_auth_id)
  );
  const auth_level = useSelector(
    (state) => state?.authReducer?.user?.auth_level
  );
  const {
    data: PortAuthorities,
    isError: isErrorPortAuthorities,
    isLoading: isLoadingPortAuthorities,
    refetch: refetchPortAuthorities,
  } = useQuery("portAuthorities", fetchPortAuthorities);
  const { data, isError, isLoading, refetch } = useQuery(
    ["applicationsApprovedOrRejectHistory", portAuthId],
    () => fetchFinishedApplications(portAuthId)
  );
  const classes = useStyles();
  const [selectedItem, setSelectedItem] = useState({});
  let history = useHistory();

  // Get portAuthorities Sorted via requirements (sort them by City with 1st DNER)
  const portAuthoritiesSorted = portAuthoritySort(PortAuthorities);
  return (
    <>
      <Helmet title={t("Applications History")} />
      <Typography variant="h3" gutterBottom display="inline">
        {t("Applications History")}
      </Typography>

      <Breadcrumbs aria-label="Breadcrumb" mt={2}>
        <Link component={NavLink} exact to="/">
          {t("Dashboard")}
        </Link>
        <Typography>{t("Approved / Rejected Applications History")}</Typography>
      </Breadcrumbs>

      <Divider my={6} />
      {auth_level === 0 ? (
        <GovGrCard>
          <Autocomplete
            id="combo-box-demo"
            onChange={(event, newValue) => {
              setportAuthId(newValue?.id);
            }}
            options={portAuthoritiesSorted || []}
            getOptionLabel={(option) => option?.dscr}
            style={{ width: 300, marginTop: 10 }}
            renderInput={(params) => (
              <TextField
                {...params}
                label={t("Port Authorities")}
                variant="outlined"
              />
            )}
          />
        </GovGrCard>
      ) : null}

      <GovGrCard>
        <CustomAlert
          open={isError}
          close={() => {
            refetch();
          }}
          message={t("A network error occured, please try again later")}
        />

        <CustomTable
          options={{
            showTitle: false,
          }}
          isLoading={isLoading}
          columns={[
            {
              title: t("mitroo_lnameA"),
              field: "lname_afora",
              // width: "100px",
            },
            {
              title: t("AFM"),
              field: "afm_ait",
              width: "100px",
            },
            {
              title: t("Protocol Number"),
              field: "reg_num",
            },
            {
              title: t("Application date"),
              field: "appl_dt",
              render: (rowData) => (
                <span>{dayjs(rowData.appl_dt).format("DD/MM/YYYY")}</span>
              ),
            },
            {
              // title: t("Surname"),
              title: t("mitroo_lnameΕ"),
              field: "lname_ait",
            },
            {
              title: t("Name"),
              field: "fname_ait",
            },
            {
              title: t("Application Kind"),
              field: "applicationKind",
            },
            {
              title: t("Application Status"),
              field: "applicationStatus",
            },
          ]}
          data={data}
          onEdit={(event, rowData) => {
            setSelectedItem(rowData);
            history.push("/editApplications/application", {
              id: rowData.id,
              viewOnly: true,
            });
          }}
          editLabel={t("View")}
        />
      </GovGrCard>
    </>
  );
};

export default ApplicationsHistory;
